import React, { Component } from 'react';
import { Typography, Tooltip } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { showNumber, statusIndexToText } from '../statusConfig';
import { amountToString } from '../../../util/tool';
import './renderlist.less';

export default class RenderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleConfig: [
        {
          "name": "商品",
          "rolWidth": 1
        },
        {
          "name": "退货成本",
          "rolWidth": 1
        },
        {
          "name": "退货申请数量",
          "rolWidth": 1
        },
        {
          "name": "退货出库数量",
          "rolWidth": 1
        },
        {
          "name": "退货原因",
          "rolWidth": 1
        },
        {
          "name": "总退货金额",
          "rolWidth": 1
        },
        {
          "name": "订单状态",
          "rolWidth": 1
        },
      ]
    };
  }

  render() {
    const { titleConfig = [] } = this.state;
    const { formateList = [],expandFn, toProductDetail } = this.props;
    return (
      <div className='render-return-list-container'>
        <div className='render-list-title'>{titleConfig.map((item, index) => <div className={index < titleConfig.length - 2 ? (index > 0 ? `render-list-title-item-normal${item.rolWidth}` : 'render-list-title-item') : 'render-list-title-item-normal'} key={index}>{item.name}</div>)}</div>
        <div className='render-list-content'>
          {
            formateList.map(item => {
              return (
                <div className='render-list-content-container' key={item.id}>
                  <div className='render-list-content-title'>
                    <div>退货单号：{item.out_order_no}</div>
                    <div>退货申请时间：{item.apply_time}</div>
                    <div>
                    供应商名称：
                      <Tooltip title={item.receiver_name}>{item?.receiver_name?.length > 10 ? item?.receiver_name?.slice(0, 10) + '...' : item?.receiver_name} </Tooltip>
                    </div>
                  </div>
                  <div className='render-list-content-products-container'>
                    <div className='render-list-content-products-container-left'>
                      {item.saleList.slice(0, item.isExpand ? showNumber : item.saleList.length).map((subItem, subIndex) => (
                        <div className='render-list-content-products-item' key={subIndex}>
                          <div className='render-list-content-detail'>
                            <div className='render-list-content-detail-product'>
                              <div className='render-list-content-detail-product-left'><img src={subItem.sku_image} alt="" /></div>
                              <div className='render-list-content-detail-product-right'>
                                <div className='pointer render-list-content-detail-product-right-title' onClick={() => toProductDetail(subItem)}>{subItem.sku_name}</div>
                                <div>规格：{subItem.sku_norms}</div>
                              </div>
                            </div>
                            <div className='render-list-content-detail-item'>¥ {`${amountToString(subItem.sku_cost)}`}</div>
                            <div className='render-list-content-detail-item'>{subItem.apply_number}</div>
                            <div className='render-list-content-detail-item'>{subItem.outbound_number}</div>
                            <div className='render-list-content-detail-item'>{subItem.return_reason}</div>
                          </div>
                        </div>
                      ))}

                      {item.saleList.length > showNumber ?
                        <div className='render-list-content-expand pointer' onClick={() => expandFn(item)}>
                          {item.isExpand ? <span><span>共<Typography.Link>{item.saleList.length}</Typography.Link>种商品，查看全部</span><DownOutlined /></span> : <span><span>收起</span><UpOutlined /></span>}
                        </div> : null}
                    </div>
                    <div className='render-list-content-products-container-right'>
                      <div className='render-list-content-products-container-right-item'>¥ {amountToString(item.outbound_cost)}</div>
                      <div className='render-list-content-products-container-right-item'>
                        <div><Typography.Link>{statusIndexToText["" + item.order_status]}</Typography.Link></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}
